import { toSearch, toParams } from 'utils/history';

export function getIndexBasedSkip(index, limit) {
  return Math.floor(index / limit) * limit;
}

export const getResult = (data) => {
  if (!data) {
    return null;
  }

  const [entity] = Object.values(data);
  return entity;
};

export const addSearchParams = (url, skip, params) => {
  if (!url) {
    return null;
  }

  const normParams = { ...params };

  if (normParams.skip) {
    delete normParams.skip;
  }

  const search = !skip
    ? toSearch(normParams)
    : toSearch({ ...normParams, skip });

  return `${url}${search}`;
};

export const getNextAndPrevIds = (currentId, entity) => {
  const result = { prevId: null, nextId: null, index: -1 };

  if (!entity || !entity.data) {
    return result;
  }

  const index = entity.data.findIndex(({ id }) => id === currentId);
  result.index = index;

  if (index > 0 && entity.data[index - 1]) {
    result.prevId = entity.data[index - 1].id;
  }

  if (index > -1 && entity.data[index + 1]) {
    result.nextId = entity.data[index + 1].id;
  }

  return result;
};

export function navigationSearchParams(search, index, limit, skip) {
  const lskip = skip !== undefined ? skip : getIndexBasedSkip(index, limit);

  const params = toParams(search);
  delete params.skip;
  delete params.listMode;
  delete params.limit;

  return lskip ? toSearch({ ...params, skip: lskip }) : toSearch(params);
}
